var map = {
	"./admintest.js": "7fJe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SPGl";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/adminStore/modules nonrecursive \.js$
// module id = SPGl
// module chunks = 1